import React from 'react'
import { Route, Switch } from 'react-router-dom'

const AppRouter = () => {
  return (
    <Switch>
      <Route
        path='/payments'
        render={routeProps => (
          <React.Fragment>
            {require('./Cybersource').default(routeProps)}
            {require('./DirectPay').default(routeProps)}
            {require('./MessagePay').default(routeProps)}
            {require('./NativeQuickPay').default(routeProps)}
            {require('./Result').default(routeProps)}
            {require('./Select').default(routeProps)}
            {require('./SessionPay').default(routeProps)}
          </React.Fragment>
        )}
      />
    </Switch>
  )
}

export default AppRouter
